import axios from 'axios'

// const webApiUrl = 'http://api.cdlucas.com/api/'
const webApiUrl = 'https://api.cdlucas.com:4430/api/'
// const webApiUrl = 'http://localhost:5160/api/'
const appid = ''

import {
	Toast
} from 'vant';

Toast.setDefaultOptions({
	overlay: false
})

import {
	Loading
} from 'element-ui';

import cookieManager from './cookieManager.js'

const service = {
	// lock: true, // 是否锁屏
	text: '正在加载...', // 加载动画的文字
	spinner: 'el-icon-loading', // 引入的loading图标
	background: 'rgba(0, 0, 0, 0.7)', // 背景颜色
	body: true,
	fullscreen: true // 全屏开关
}
const loadingInstance = null;
const user = null;

const request = {
	//核心请求方法
	send(config = {}) {
		var _this = this;

		_this.user = cookieManager.getUser();
		// console.log(_this.user, '_this.user')
		if (_this.user != null) {
			if (config.data == null) {
				config.data = {}
			}
			config.data.uid = _this.user.uid;
			config.data.token = _this.user.token;
		} else {
			if (config.data == null) {
				config.data = {}
			}
		}

		// console.log(config.data)

		if (config.url.indexOf("http") == -1 || config.url.indexOf("static") == 0) {
			config.url = webApiUrl + config.url;
		}
		if (config.loading) {
			_this.loadingInstance = Loading.service(service)
		}

		config.method = config.method || 'get';
		return new Promise((resolve, reject) => {
			try {
				axios.request(config).then(function(response) {
					if (config.loading) {
						_this.loadingInstance.close();
					}

					// console.log(_this.user, '_this.user in response')
					//再获取到用户数据的情况下更新token
					if (_this.user != null) {
						_this.user.token = response.data.token
						cookieManager.setUser(_this.user);
					}
					resolve(response);
				}).catch((ex) => {
					if (config.loading) {
						_this.loadingInstance.close();
					}
					Toast.fail(ex.message)
					reject(ex);
				})
			} catch (ex) {
				console.log(ex)
				reject(ex);
			}
		})
	},
	get(url, config = {}) {
		config.url = url;
		return this.send({
			url: url,
			data: config.data,
			method: 'GET',
			loading: config.loading
		})
	},
	post(url, config = {}) {
		config.url = url;
		return this.send({
			url: url,
			data: config.data,
			method: 'POST',
			loading: config.loading
		})
	}
}
export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js